export class Level {
    id : number;
    levelCode : string;
    levelName : string;
}